<template>
    <div id="feaure_mapping" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleHeader" v-if="$route.params.id > 0">Update Feature Mapping</span>
                    <span class="page-title" id="vehicleHeader" v-else>Add Asset Mapping</span>
                    <!-- <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i>    Back
                    </button> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VehicleFeatureForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <template>
                                        <div class="purchase-order-create-main table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th scope="col" style="width:400px">Sequence</th>
                                                        <th scope="col" style="width:1000px">Feature</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(feature, index) in featureObjArr" :key="index">
                                                        <td>
                                                            <span>{{feature.sequence}}</span>
                                                        </td>
                                                        <td>
                                                            <v-select v-model="feature.feature_val" name="feature" placeholder="Select Feature."
                                                                        label="text"
                                                                        :options="featureValArr" @input="onFeatureSelect($event,index)">
                                                            </v-select>
                                                            <div class="field-error">{{feature.feature_error}}</div>
                                                        </td>
                                                        
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                    </template>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleBtn" class="btn btn-primary" v-on:click.prevent="CreateFeature">
                                        <i class="fp-reload"> </i>  Save
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    // import { store } from "../store/extraFeaturesStore.js";
    import {commonMixins} from '../mixins/commonMixins';
    import {contractMixins} from '../mixins/contractMixins';
    
    export default {
        name: "FeatureMapping",
        mixins:[commonMixins,contractMixins],
        data:() => ({
                featureObjArr:[],
                cantAccessPage:'',
                permissions: [],
                loading:false,
                assetId:"",
                assetFeature:[],
                unitNo:"",
                featureValArr:[],
            }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_asset') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
           
            self.loadFieldData(['feature']);
            self.loadFeatures();
            
        },
        methods: {

            loadFeatures() {
                
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/mapped-feature/fetch",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    crossDomain: true,
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.featureObjArr = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-extrafeture-get');

                    }
                });
            },
            CreateFeature()
            {
                var self = this;
                var fields =[];
                var error = false;
                var checkArr = [];
                if (self.featureObjArr.length){
                    for(var i=0;i<self.featureObjArr.length;i++){
                        if (self.featureObjArr[i] != null){
                            if(self.featureObjArr[i].feature_val != null && self.featureObjArr[i].feature_val.value){
                                self.featureObjArr[i].feature_error = '';
                                if (checkArr.includes(self.featureObjArr[i].feature_val.value)){
                                    self.featureObjArr[i].feature_error = 'Feature Already Selected';
                                    error=true;
                                }else{
                                    checkArr.push(self.featureObjArr[i].feature_val.value);
                                }
                            }
                        }
                    }
                }

                if (!error){
                    self.loading = true;

                    fields.push({name:"featureArr",value:JSON.stringify(self.featureObjArr)});

                    $.ajax({
                        url: process.env.ROOT_API + "/feature-mapping/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            
                            self.loadFeatures();
                        },
                        error: function (jqXHR, exception) {

                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'feature-mapping-create')
                        }
                    });
                }
            },

            onFeatureSelect:function(evt,index){
                var self = this;
                var checkArr = [];
                if (self.featureObjArr.length){
                    for(var i=0;i<self.featureObjArr.length;i++){
                        if (self.featureObjArr[i] != null){
                            if(self.featureObjArr[i].feature_val != null && self.featureObjArr[i].feature_val.value){
                                self.featureObjArr[i].feature_error = '';
                                if (checkArr.includes(self.featureObjArr[i].feature_val.value)){
                                    self.featureObjArr[i].feature_error = 'Feature Already Selected';
                                }else{
                                    checkArr.push(self.featureObjArr[i].feature_val.value);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FeatureMapping.vue